// prettier-ignore
export const environment = {
  production: false,
  staging: false,
  urlApiPlatform: 'https://api.dev.feiradolivro.com.br/livro-api-platform/',
  //urlApiPlatform: 'https://localhost:30010/',
  // Link do pedido de venda no ERP Base ({id} = base_order_id da venda). Ambiente sandbox.
  urlErpBaseOrder: 'https://app-sandbox.baseerp.com.br/#/comercial/pedido-de-venda/edit/{id}',
};
